module.exports = __webpack_public_path__ + "img/1-2.dc227be2.jpg";